<template>
  <div>
    <!-- 横幅 -->
    <div class="about_banner">
      <img src="../assets/about/banner.png" />
    </div>

    <!-- 旗下应用 -->
    <div class="app-list">
      <div class="app-text">旗下应用</div>
      <img src="../assets/about/book-logo.png" class="icon-img" @click="linkImg('/detail/book.html')"/>
      <img src="../assets/about/now-logo.png" class="icon-img" @click="linkImg('/detail/now.html')"/>
      <img src="../assets/about/hotpot-logo.png" class="icon-img" @click="linkImg('/detail/hotpot.html')"/>
      <img src="../assets/about/tomato-logo.png" class="icon-img" @click="linkImg('/detail/tomato.html')"/>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'About',
    data () {
      return {}
    },
    methods: {
      linkImg (url) {
        window.location.href = url // 在本页面打开外部链接
		  }
    }
  }
</script>
<style lang="less" scoped>
  .about_banner {
    img {
      width: 100%;
    }
  }

  .app-list{
    height: 150px;
    color: #22102f;
    font-size: 25px;
    text-align: center;
    .icon-img {
      width: 50px;
      height: 50px;
      margin: 30px;
    }
  }
</style>
